import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkbox", "input", "container"];

  connect() {
    this.toggle();
  }

  toggle() {
    const enabled = this.checkboxTarget.checked;

    this.inputTargets.forEach(input => {
      input.disabled = !enabled;
    });

    this.containerTargets.forEach(container => {
      container.classList.toggle("opacity-50", !enabled);
    });
  }
}
